export const AGR_FREE_DATA = 'AGR_FREE_DATA'
export const AGR_GET_DEPT_USERS = 'AGR_GET_DEPT_USERS'

export const AGR_SET_REQUESTS_LOADING_STATE = 'AGR_SET_REQUESTS_LOADING_STATE'
export const AGR_GET_CURRENT_REQUEST = 'AGR_GET_CURRENT_REQUEST'
export const AGR_SET_CURRENT_REQUEST = 'AGR_SET_CURRENT_REQUEST'
export const AGR_GET_DOC_STATUS_LIST = 'AGR_GET_DOC_STATUS_LIST'

export const AGR_ADD_DETAILS = 'AGR_ADD_DETAILS'
export const AGR_DEL_DETAILS = 'AGR_DEL_DETAILS'
export const AGR_GET_INVOICES = 'AGR_GET_INVOICES'
export const AGR_ADD_ROW = 'AGR_ADD_ROW'
export const AGR_DEL_ROW = 'AGR_DEL_ROW'
export const AGR_UPD_ROW = 'AGR_UPD_ROW'
export const AGR_UPD_HEADER = 'AGR_UPD_HEADER'
export const AGR_UPD_ROW_PLACE = 'AGR_UPD_ROW_PLACE'

export const AGR_CLEAR_REQUEST_LIST = 'AGR_CLEAR_REQUEST_LIST' // Очистка списка запросов на КП
export const AGR_GET_REQUEST_LIST = 'AGR_GET_REQUEST_LIST' // Получение списка запросов на КП, согласно установленному текущему фильтру
export const AGR_SET_REQUEST_FILTER = 'AGR_SET_REQUEST_FILTER' // Установка текущего фильтра за статус запросов, входящих в список

export const AGR_CREATE_REQUEST = 'AGR_CREATE_REQUEST' // Создание нового запроса
export const AGR_CANCEL_REQUEST = 'AGR_CANCEL_REQUEST' // Отмена запроса
export const AGR_POST_REQUEST = 'AGR_POST_REQUEST' // Изменение состояния запроса
export const AGR_ADD_FILE = 'AGR_ADD_FILE' // Добавление файла к запросу
export const AGR_DEL_FILE = 'AGR_DEL_FILE' // Удаление файла из запроса
export const AGR_CONFIRM_FILE = 'AGR_CONFIRM_FILE' // Согласование файла из запроса
export const AGR_CHANGE_COMMENT = 'AGR_CHANGE_COMMENT' // Добавление/обновление комментария
export const AGR_DELETE_COMMENT = 'AGR_DELETE_COMMENT' // Удаление комментария
